module.exports = __webpack_public_path__ + "stylesheets/global_4e0434a866bef428efc3982f728873da.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 154